import { jsx, jsxs } from "react/jsx-runtime";
import { Accordion, Text, Link } from "@nxt-costco-com/forge-components";
import { SpaceSm, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../Analytics/index.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { COMPONENT_NAME } from "./constants.js";
function Container({
  children,
  enableNavigation,
  navigationLabel,
  hasTitle,
  entryId,
  sx,
  target
}) {
  if (!enableNavigation) {
    return /* @__PURE__ */ jsx(CostcoBox, { sx, children });
  }
  return hasTitle ? /* @__PURE__ */ jsx(
    CostcoBox,
    {
      "aria-labelledby": `link-list-heading-${entryId}`,
      component: "nav",
      "data-testid": COMPONENT_NAME,
      sx,
      children
    }
  ) : /* @__PURE__ */ jsx(
    CostcoBox,
    {
      "aria-label": navigationLabel,
      component: "nav",
      "data-testid": COMPONENT_NAME,
      sx,
      children
    }
  );
}
function Title({
  title,
  url,
  entryId,
  analyticsTitlePrefix,
  target
}) {
  let analyticsTitle = title;
  if (analyticsTitlePrefix) {
    analyticsTitle = `${analyticsTitlePrefix} | ${analyticsTitle}`;
  }
  return !title ? null : /* @__PURE__ */ jsx(
    Text,
    {
      component: "h2",
      id: `link-list-heading-${entryId}`,
      sx: { paddingBottom: SpaceSm },
      variant: "t4",
      children: url ? /* @__PURE__ */ jsx(
        Analytics,
        {
          analyticData: {
            component: {
              trackedData: [analyticsTitle]
            }
          },
          children: /* @__PURE__ */ jsx(
            Link,
            {
              href: url,
              sx: { color: ColorGray900 },
              target,
              children: title
            }
          )
        }
      ) : title
    }
  );
}
function LinkListContainer({
  title,
  url,
  enableNavigation,
  children,
  entryId,
  navigationLabel,
  variant,
  sx,
  ariaLabel,
  ariaDescribedBy,
  analyticsTitlePrefix,
  target
}) {
  const isAccordion = variant === "Accordion";
  const enableNav = Boolean(enableNavigation);
  const navLabel = String(navigationLabel);
  const hasTitle = Boolean(title);
  if (isAccordion) {
    return /* @__PURE__ */ jsx(
      Accordion,
      {
        title,
        variant: "t4",
        ...ariaDescribedBy && { ariaDescribedBy },
        ...ariaLabel && { ariaLabel },
        children: /* @__PURE__ */ jsx(
          Container,
          {
            enableNavigation: enableNav,
            entryId,
            hasTitle,
            navigationLabel: navLabel,
            target,
            children
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    Container,
    {
      enableNavigation: enableNav,
      entryId,
      hasTitle,
      navigationLabel: navLabel,
      sx,
      children: [
        /* @__PURE__ */ jsx(
          Title,
          {
            entryId,
            title,
            url,
            analyticsTitlePrefix,
            target
          }
        ),
        children
      ]
    }
  );
}
export {
  LinkListContainer
};
